import { Component, Input, OnChanges } from "@angular/core";
import { GoogleMapsService } from "src/services/google-maps/google-maps.service";
import { LatLng } from "src/services/subscription/base-location-lat-lng.const";
import { delay } from "src/services/utils/promise.utils";

@Component({
  selector: "rc-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
  standalone: false,
})
export class MapComponent implements OnChanges {
  @Input() public latitude: string | number;
  @Input() public longitude: string | number;
  @Input() public defaultCenter: LatLng | undefined;
  @Input() public zoom: number = 12;
  @Input() public disablePinchZoom: boolean = false;
  protected isLoading: boolean = true;
  protected shouldDisplayMap: boolean = true;
  protected mapImageUrl: string;

  constructor(public readonly googleMapsService: GoogleMapsService) {}

  public ngOnChanges() {
    const hasSelectedLocation = !!this.latitude && !!this.longitude;
    this.shouldDisplayMap = hasSelectedLocation || !!this.defaultCenter;

    if (hasSelectedLocation) {
      this.mapImageUrl = this.googleMapsService.generateStaticMapUrlFromCoordinates(
        this.latitude,
        this.longitude,
        this.zoom,
      );
    } else if (this.defaultCenter) {
      this.mapImageUrl = this.googleMapsService.generateStaticMapUrlWithoutMarker(
        this.defaultCenter.lat,
        this.defaultCenter.lng,
        this.zoom,
      );
    }
  }

  public async onImageDidLoad(): Promise<void> {
    await delay(200);
    this.isLoading = false;
  }
}
